import React from "react";
import { Button } from "semantic-ui-react";

const NumPad = (props) => {
  const { onResetClick, onBackSpaceClick, onClick, mini = false } = props;

  return (
    <>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => {
        return (
          <Button
            key={i}
            type="button"
            primary
            size={mini ? "medium" : "massive"}
            style={{
              marginRight: i % 3 === 0 ? "0em" : "0.2em",
              marginBottom: "0.2em",
              width: "32.2%",
            }}
            onClick={() => onClick(`${i}`)}
            content={i}
          />
        );
      })}
      <Button
        type="button"
        negative
        size={mini ? "medium" : "massive"}
        style={{
          marginRight: "0.2em",
          width: "32.2%",
          marginBottom: "0.2em",
        }}
        icon={mini ? "arrow left" : "redo"}
        onClick={() => onResetClick?.()}
      />

      <Button
        type="button"
        primary
        size={mini ? "medium" : "massive"}
        style={{
          marginRight: "0.2em",
          marginBottom: "0.2em",
          width: "32.2%",
        }}
        content="0"
        onClick={() => onClick("0")}
      />

      <Button
        type="button"
        negative
        size={mini ? "medium" : "massive"}
        style={{
          marginRight: "0em",
          marginBottom: "0.2em",
          width: "32.2%",
        }}
        content="."
        onClick={() => onClick(".")}
      />
    </>
  );
};

export default NumPad;
